// Power usage per month identity + display
export const PUM_TARGET = 'powerMonth';
export const PUM_REGISTRY_KEY = 'powerUsageMonth:v1';
export const PUM_COST_DECIMALS = 2;
export const PUM_KWH_DECIMALS = 0;

// Day pushes trigger a refetch of the current month, at most once per PUM_REFRESH_MS
export const PUM_REFRESH_MS = 60 * 1000;

// Forecast defaults: base month = january (no sun, high usage), price per kWh
export const PUM_FORECAST_BASE_MONTH = 0;
export const PUM_FORECAST_PRICE = 0.35;
